import React, { useCallback } from "react"

export default function DateInputCol({ fontPct, disabled, ts, setTs, status, setStatus }) {
  const updateDate = useCallback((e) => {
    e.preventDefault()
    setTs(e.target.value)
    setStatus(true)
  }, [])

  return (
    <div className={"col-5"} style={{ padding: "0" }}>
      <input
        type={"datetime-local"}
        className={"form-control form-control-sm"}
        style={{
          fontSize: `${fontPct}%`,
          border: `${status ? "3px solid var(--lanzalake-orange)" : "1px solid var(--lanzalake-grey"}`,
        }}
        value={ts}
        disabled={disabled}
        onChange={updateDate}
      />
    </div>
  )
}
